import './active-claims-modal.scss';

import { Box } from '@mui/material';
import { FormCheckBoxField } from '../../../../presentation/components';

export interface WarningConfirmationProps {
  isChecked: boolean;
  setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}
export const NoActiveClaimsConfirmation = ({
  isChecked,
  setIsChecked,
  setIsDisabled,
}: WarningConfirmationProps) => {
  return (
    <>
      <Box className="context">
        Before proceeding, please verify that this insured does not have any
        active claims. If there are any open claims, then cancel the transaction
        and escalate this to the{' '}
        <strong className={'bold-text'}> Underwriting Manager</strong>. If there
        are no active claims, then you can continue.
      </Box>
      <FormCheckBoxField
        name=""
        label="This insured does not have any open claims"
        customWeight="400"
        customFont="16px"
        size="medium"
        checked={isChecked}
        handleChange={(e) => {
          setIsChecked(e.target.checked);
          setIsDisabled(!e.target.checked);
        }}
      />
    </>
  );
};
